var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUntag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1 14.742 4.945-.709-.706 4.967 5.962-5.985-4.069-4.429zm17.664-9.221c.391-.393.5-.945 0-1.419l-2.826-2.839c-.279-.308-1.021-.392-1.412 0l-3.766 3.78 4.068 4.429zm.042 9.772-14.001-14a.999.999 0 1 0 -1.414 1.414l14.001 14a.996.996 0 0 0 1.414 0 .999.999 0 0 0 0-1.414z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntag);
export default __webpack_public_path__ + "static/media/untag.716f326ea6cbfa8a35a64fc257e9e8d9.svg";
export { ForwardRef as ReactComponent };